<template>
  <loading v-if="isLoading"></loading>
  <not-found v-else-if="!form"></not-found>
  <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
  <div v-else>
    <Result :isDetail="true" :form="form" :result="result" is-detail></Result>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Loading from "../../Base/Loading/Loading.vue";
import NotFound from "../../Base/NotFound.vue";
import Result from "./Result.vue";
import authorize from "./authorize";
export default {
  mixins: [authorize],
  components: {
    Loading,
    NotFound,
    Result,
  },
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
      creatingPdf: false,
      form: {},
      result: {},
    };
  },
  methods: {
    setForm(data) {
      this.isLoading = false;
      this.form = data;
      this.result = {
        status: true,
        calculatedE3: data.resultCalculatedE3,
        averageWallHeatTransferCoefficient:
          data.resultAverageWallHeatTransferCoefficient,
        groundHeatTransferCoefficient: data.resultGroundHeatTransferCoefficient,
        ceilingHeatTransferCoefficient:
          data.resultCeilingHeatTransferCoefficient,
        adjacentWallHeatTransferCoefficient:
          data.resultAdjacentWallHeatTransferCoefficient,
        roomHeatGainWithoutSolar: data.resultRoomHeatGainWithoutSolar,
        mainRoomSolarHeatGain: data.resultMainRoomSolarHeatGain,
        mainRoomHeatGeneration: data.resultMainRoomHeatGeneration,
        auxiliaryRoomHeatGainWithoutSolar:
          data.resultAuxiliaryRoomHeatGainWithoutSolar,
        auxiliaryRoomSolarHeatGain: data.resultAuxiliaryRoomSolarHeatGain,
        auxiliaryRoomHeatGeneration: data.resultAuxiliaryRoomHeatGeneration,
        totalThermalLoad: data.resultTotalThermalLoad,
        requiredCoolingCapacity: data.resultRequiredCoolingCapacity,
        safetyFactor: data.resultSafetyFactor,
        totalRequiredCoolingCapacity: data.resultTotalRequiredCoolingCapacity,
        mainRoomVolumetricFlow: data.resultMainRoomVolumetricFlow,
        auxiliaryRoomVolumetricFlow: data.resultAuxiliaryRoomVolumetricFlow,
        auxiliaryRoomAverageTemperature:
          data.resultAuxiliaryRoomAverageTemperature,
        expectedAirLeakage: data.resultExpectedAirLeakage,
        condensationAmount: data.resultCondensationAmount,
        requiredDeviceCoolingCapacityForRoom:
          data.resultRequiredDeviceCoolingCapacityForRoom,
        mainRoomRadiationHeatGain: data.resultMainRoomRadiationHeatGain,
      };
    },
    async getItem() {
      if (this.autoPrint) return this.setForm();
      this.isLoading = true;
      const response = await Requests.HeatGain.GetHeatGainDoubleRoomById({
        params: {
          id: this.$route.params.id,
        },
      });
      if (response.message === "OK") {
        this.setForm(response.data);
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>

<style scoped>
page {
  background: white;
  display: block;
  margin: 0 auto;
  position: relative;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}

.page_header {
  position: running(header);
  width: 100%;
}

.page_footer {
  position: running(footer);
  width: 100%;
}

.pdf-content {
  padding: 20px;
}
</style>
